import { clearSupplierClaimClientSession } from '@/features/supplier-claim/api/supplierClaim.api';
import { useMsal } from '@azure/msal-react';
import { useQueryClient } from '@tanstack/react-query';

import { resetIdentity } from '../posthogIdentity';

const useAppLogOut = () => {
  const { instance } = useMsal();
  const queryClient = useQueryClient();

  const logoutOfApp = async () => {
    // Clear React Query cache first to prevent stale data from previous user sessions
    queryClient.clear();

    clearSupplierClaimClientSession();
    resetIdentity();

    // Clear active account
    instance.setActiveAccount(null);

    // Clear all MSAL-related localStorage keys BEFORE redirect
    // MSAL stores keys with multiple patterns:
    // 1. msal.* - metadata keys (msal.account.keys, msal.token.keys.*)
    // 2. {homeAccountId}-{environment}-* - token/account data keys
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        // Match MSAL metadata keys
        if (key.startsWith('msal.')) {
          keysToRemove.push(key);
        }
        // Match token/account keys that contain B2C identifiers
        if (key.includes('b2clogin.com') || key.includes('b2c_1a_')) {
          keysToRemove.push(key);
        }
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));

    // Perform logout redirect - this MUST be last as it navigates away
    await instance.logoutRedirect({
      postLogoutRedirectUri: '/'
    });
  };

  return logoutOfApp;
};
export default useAppLogOut;
